export default __webpack_public_path__ + "static/media/facet002.63723904.png";